// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Settings_breadcrumbs__UVa53","setting-group":"Settings_setting-group__jltA5","setting-group-title":"Settings_setting-group-title__nceS9"};